import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import Participant from './Participant';

class ParticipantContainer extends React.Component {
    state = {
      currentHover: null,
      showWarning: false,
    };

    handleMouseEnter = index => () => {
      // We don't care about the actual event, so we just disregard that
      this.setState({ currentHover: index });
    };

    // Here, we don't event use the variable event (this is more accepted)
    handleMouseOut = () => {
      this.setState({ currentHover: null });
    };

    handleOnClickParticipant = participants => () => {
      const { minParticipants } = this.props.settings;

      if (participants < minParticipants) {
        this.setState({ showWarning: true });
      } else {
        this.setState({ showWarning: false });

        this.props.onClickParticipant(participants);
      }
    };

    render() {
      const {
        items, onClickParticipant, activeParticipant, lang,
      } = this.props;
      const { currentHover, showWarning } = this.state;

      if (this.props.items && this.props.items.length === 0) {
        return [];
      }

      return (
        <Card title={lang.topic}>
          {items.length > 50 ? (
            <select
              value={activeParticipant}
              onChange={event => this.handleOnClickParticipant(parseInt(event.target.value, 10))()}
            >
              {items.map(({ name, value }, index) => (
                <option key={index} value={value}>{name} deltagare</option>

              ))}
            </select>
          ) : (
            <ul className="list-inline" >
              {items.map(({ name, value, icon }, index) => {
                const active = activeParticipant === value;
                return (
                  <Participant
                    key={value}
                    name={name}
                    value={value}
                    icon={icon}

                    onMouseEnter={this.handleMouseEnter(index)}
                    onMouseOut={this.handleMouseOut}
                    onClick={() => this.handleOnClickParticipant(value)}

                    active={active}
                    clicked={false}
                    isHover={currentHover === index}
                  />);
              })}
            </ul>
          )}


          {showWarning && (
            <div className="alert alert-danger col-xs-12">
              {lang.minimumParticipants}
            </div>
          )}
        </Card>
      );
    }
}
// Todo: PropTypes

ParticipantContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    icon: PropTypes.string.isRequired,
  })).isRequired,
  activeParticipant: PropTypes.number,
  onClickParticipant: PropTypes.func.isRequired,
};

export default ParticipantContainer;



// WEBPACK FOOTER //
// ./src/components/Resource/components/ParticipantContainer.js